import React, { Component } from 'react';
import styles from './garages.module.scss';
import animations from '../../css/animations.scss'
import classnames from 'classnames';
import { CSSTransition } from "react-transition-group"

import API from '../../components/utils/API';
import SSE from '../../components/utils/SSE'
import { strings } from '../../components/utils/translations';
import history from '../../components/utils/routes/history';
import { publish } from '../../components/utils/events'
import { DarkModeContext } from '../../providers/DarkModeContext'
import { BottomScrollListener } from 'react-bottom-scroll-listener'

import PrimaryButton from '../../components/Buttons/primaryButton';
import Loader from '../../components/Loader/index';
import DoorCard from '../../components/DoorCard/DoorCard';
import SideMenu from '../../components/SideMenu/sideMenu';

import CloseIcon from '../../img/icons/closeIcon';
import CameraIcon from './../../img/icons/camera-icon.svg';
import BoxIcon from './../../img/icons/box-icon.svg';
import InfiniteIcon from './../../img/icons/infinite-icon.svg';
import LockIcon from './../../img/icons/lock_closed.svg';
import ProximityIcon from './../../img/icons/proximity-icon.svg';
import EthernetIcon from './../../img/icons/ethernet-icon.svg';
import SearchIcon from '../../img/icons/magnifyingglass.svg'

import DetailDoor from '../Detail/detailDoor';
import PermissionMain from '../Permissions/permissionMain';
import RemotesButton from '../../components/RemotesButton/RemotesButton'

import { notification, Input } from 'antd'

const PAGE_SIZE = 5

export default class GaragesPage extends Component
{
    static contextType = DarkModeContext
    
    constructor(props)
    {
        super(props);

		this.state =
		{
            houses: [],
            house: null,
            door: null,
			isRefreshing: false,
            openGarageDetails: false,
            selectedDoorId: null,
            openFeaturesDetailsModal: false,
            houseName: null,
            openPermissions: false,
            searchInput: null
		}

        this.houses = []
        this.currentPage = 1
        this.hasCachedHouses = false
        this.cachedHouses = []

		this.doorsRefs = {}
        this.initialLinkingUrl = null;
    }

	componentDidMount()
	{
        this.loadCachedHouses()
        this.getMyPermissions()
    }

    /**
     * Paints the houses cached from the previous session right away, so an
     * already logged user does not stare at the loader while getHouses()
     * resolves. It is a partial, trimmed down list meant only for this first
     * render: onFinishedGettingHouses() replaces it with the complete one.
     */
    loadCachedHouses()
    {
        const cachedHouses = API.getInstance().getCachedHouses()

        console.log(cachedHouses)
        if (cachedHouses == null || cachedHouses.length === 0)
            return

        // Deliberately NOT stored in this.houses: these doors are trimmed down
        // for rendering, so they must not reach PermissionMain & co, which read
        // fields (myPermission.virtualRemotes) that the cache drops.
        this.hasCachedHouses = true
        this.cachedHouses = cachedHouses

        this.setState({ houses: cachedHouses.slice(0, PAGE_SIZE*this.currentPage) })
    }

    /**
     * The list the garages view paginates and searches over: the cached one
     * until the fresh data arrives, the real one from then on. For rendering
     * only; anything that needs complete doors must read this.houses.
     */
    getVisibleHouses()
    {
        return (this.hasCachedHouses) ? this.cachedHouses : this.houses
    }

    render()
	{
        const { darkMode } = this.context
        
        const noGaragesView =
        <div className={styles.noGaragesViewContainer}>
            <div className={styles.noGaragesView}>
                <img
                    src={
                        darkMode ?
                        require('../../img/no_garages_dark.png').default :
                        require('../../img/no_garages.png').default
                    }
                    className={styles.noGarageImg}
                />
                <div className={styles.noGarageContent}>
                    <h4 className={styles.noGarageTitle}>
                        { strings('noGaragesTitle') }
                    </h4>
                    <p className={styles.text}>
                        { strings('noGaragesDescription') }
                    </p>
                </div>
            </div>
        </div>;

        const doorsView = (this.state.houses.length > 0 || this.state.searchInput?.length > 0) ?
            <>
                {
                    this.state.houses.map((item) => (
                    <div key={item.id} className={styles.houseItem}>
                        <h4 className={styles.houseTitle}>
                            { item.name }
                        </h4>
                        <div className={styles.doorList}>
                            { this.renderHouseItem.call(this, item) }
                        </div>
                    </div>
                ))}
            </>
            : noGaragesView

        const innerView =
            <BottomScrollListener onBottom={this.onScrolledToBottom.bind(this)}>
            { (scrollRef) => (
                <div ref={scrollRef} className={styles.dashboard}>
                    <div className={styles.dashboardTopBar}>
                        <h3 className={styles.title}>{ strings('garagesTitle')}</h3>
                        {
                            (this.state.houses?.length > 0 || this.state.searchInput?.length > 0) &&
                            <Input
                                className={styles.searchInput}
                                placeholder={strings('garagesSearchPlaceholder')}
                                allowClear
                                prefix={
                                    <img
                                        className={styles.searchIcon}
                                        src={SearchIcon}
                                    />
                                }
                                onChange={this.onSearchInput.bind(this)}
                            />
                        }
                    </div>
                    {
                        (this.state.openPermissions) &&
                        <PermissionMain
                            houses={this.getFilteredHousesBySearch()}
                            door={(this.state.selectedDoorId != null) ? this.state.door : null}
                            closePermissions={() => {
                                if (this.state.selectedDoorId != null) 
                                    publish('refresh-detail-remotes')
                                
                                this.setState({ openPermissions: false })
                            }}
                        />
                    }
                    <div className={styles.garagesContent}>
                        {
                            (!this.state.isRefreshing) ? doorsView
                            : <div className={styles.loaderContainer}><Loader large spinner gray /></div>
                        }
                    </div>
                    
                    {
                        (this.state.houses.length > 0 && this.state.openGarageDetails === false &&
                         !this.hasCachedHouses) &&
                        <RemotesButton
                            title={strings('giveRemotes')}
                            onClick={() => this.openPermissions()}
                        />
                    }
                </div>
            )}
            </BottomScrollListener>

		return (
            <div className="dashboardContainer">
                <SideMenu />
                
                <div className={classnames(styles.garagesContainer, {[styles.detailOpen]: this.state.openGarageDetails })}>
                    { innerView }

                    {
                        (this.state.openFeaturesDetailsModal == true) &&
                        <div className={styles.overlay}>
                            <div className={styles.featuresModal}>
                                <div className={styles.featuresModalTopBar}>
                                    <h3 className={styles.title}>Estado actual de tu puerta</h3>
                                    <CloseIcon className={styles.closeIcon} size="16" onClick={() => this.setState({ openFeaturesDetailsModal: !this.state.openFeaturesDetailsModal })} />
                                </div>
                                <div style={{ marginTop: '36px' }}>
                                    <div className={styles.optionBox}>
                                        <img className={styles.icon} src={InfiniteIcon} alt=""/>
                                        <p className={styles.text}>Permiso <strong>ilimitado</strong></p>
                                    </div>
                                    <div className={styles.optionBox}>
                                        <img className={styles.icon} src={EthernetIcon} alt=""/>
                                        <p className={styles.text}>Conectado por <strong>Ethernet</strong></p>
                                    </div>
                                    <hr className={styles.separator} />
                                    <div className={styles.optionBox}>
                                        <img className={styles.icon} src={LockIcon} alt=""/>
                                        <p className={styles.text}>Puerta <strong>cerrada</strong></p>
                                    </div>
                                    <hr className={styles.separator} />
                                    <div className={styles.optionBox}>
                                        <img className={styles.icon} src={ProximityIcon} alt=""/>
                                        <p className={styles.text}>Apertura por <strong>Proximidad</strong></p>
                                    </div>
                                    <div className={styles.optionBox}>
                                        <img className={styles.icon} src={BoxIcon} alt=""/>
                                        <p className={styles.text}><strong>Entrega segura</strong> en garaje</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                
                <CSSTransition
    				classNames='detailViewAnimation'
    				timeout={300}
    				in={this.state.openGarageDetails}
    				mountOnEnter={true}
    				unmountOnExit={true}
    			>
                    <DetailDoor
                        house={this.state.house}
                        door={this.state.door}
                        isOpen={this.state.openGarageDetails}
                        openFeaturesDetailsModal={() => this.setState({ openFeaturesDetailsModal: !this.state.openFeaturesDetailsModal })}
                        onClickClose={() => this.setState({ openGarageDetails: false, selectedDoorId: null })}
                        openPermissions={this.openPermissions.bind(this)}
                        onDeletePermission={() =>
                        {
                            // Refresh permissions in case there are VR changes (maybe you removed a permission)
                            this.getMyPermissions()
                        }}
                    />
                </CSSTransition>
            </div>
		);
    }

	getHouseByDoor(doorId)
	{
		let h = null;

		for (let i = 0; i < this.state.houses.length && h == null; i++)
		{
			let house = this.state.houses[i];

            if (house.doors != null)
            {
    			for (let j = 0; j < house.doors.length && h == null; j++)
    			{
    				if (house.doors[j].id == doorId)
    					h = house;
    			}
            }
            else if (house.nodes != null)
            {
                for (let j = 0; j < house.nodes.length && h == null; j++)
    			{
                    if (house.nodes[j].doors != null)
                    {
                        for (let k = 0; k < house.nodes[j].doors.length && h == null; k++)
            			{
            				if (house.nodes[j].doors[k].id == doorId)
            					h = house;
            			}
                    }
    			}
            }
		}
        
        return h
    }
    getDoor(doorId)
    {
        let door = null;

        for (let i = 0; i < this.houses.length && door == null; i++)
        {
            if (this.houses[i].doors != null)
            {
                for (let j = 0; j < this.houses[i].doors.length && door == null; j++)
                {
                    if (this.houses[i].doors[j].id === doorId)
                        door = this.houses[i].doors[j];
                }
            }
        }
        
        // history.push(`/garages/door/${doorId}`);
        return door;
    }

    openPermissions()
    {
        // The cached doors are trimmed for rendering and lack the fields this
        // flow reads (myPermission.virtualRemotes), so wait for the fresh ones.
        if (this.hasCachedHouses)
            return

        this.setState({ openPermissions: true })
    }

    getHouseByDoorItem(item)
    {
        API.getInstance().getUsersHousesWithDoors()
		.then(response =>
		{
            var h = null;

            for (var i = 0; i < response.data.length && h == null; i++)
            {
                var house = response.data[i];
                this.setState({ house: house, houseName: house.name })
            }
        })
        .catch(error =>
        {
            console.log(error);
        });

        this.setState({
            door: item,
            openGarageDetails: true
        })
    }
    renderHouseItem(item)
    {
        return (
            (item.doors != null) ?
                item.doors.map((d) => (
                    <DoorCard
                        key={`${d.id}`}
                        id={`door-${d.id}`}
                        name={d.name}
                        door={d}
                        image={d.imageURL}
                        onClickOpenDetailDoor={() => this.onDoorClicked(d)}
                        selectedDoor={d.id === this.state.selectedDoorId}
                    />
                )
            )
            :
            (
                (item.nodes != null && item.nodes.length > 0) &&
                item.nodes.map((node) =>
                {
                    return node.doors.map((d) =>
                    {
                        return (
                            <div key={d.id}>
                                <DoorCard
                                    id={`door-${d.id}`}
                                    name={d.name}
                                    door={d}
                                    image={d.imageURL}
                                    onClickOpenDetailDoor={() => this.onDoorClicked(d)}
                                    selectedDoor={d.id === this.state.selectedDoorId}
                                />
                            </div>
                        )
                    })
                })
            )
        )
    }

    getMyPermissions()
	{
        // With cached houses on screen, refresh silently instead of blanking them out
        this.setState({ isRefreshing: this.houses.length === 0 && !this.hasCachedHouses })
        
		API.getInstance().getHouses()
		.then(response =>
		{
            this.houses = []
            let houses = []
            
            response.data.map((permission) =>
            {
                if (permission.activationDate != null &&
                    permission.PermissionNode != null &&
                    permission.PermissionNode.PermissionHouse != null)
                {
                    const permissionNode = permission.PermissionNode;
                    const permissionHouse = permissionNode.PermissionHouse;
                    const permissionDoor = permission.PermissionDoor;

                    var house = houses.find(h => h.id === permissionHouse.id);
                    if (house == null)
                    {
                        house =
                        {
                            id: permissionHouse.id,
                            userId: permissionHouse.userId,
                            name: permissionHouse.name,
                            doors: [],
                            nodeId: permissionNode.id,
                            place: permissionHouse.place,
                            type: permissionHouse.type
                        }
                        houses.push(house);
                    }

                    var d =
                    {
                        id: permissionDoor.id,
                        name: permissionDoor.name,
                        permissionId: permission.id,
                        roleType: permission.roleType,
                        hubId: permissionNode.hubId,
                        actuatorId: permissionDoor.actuatorId,
                        sensorId: permissionDoor.sensorId,
                        isOpen: permissionDoor.isOpen,
                        changeStatusAt: permissionDoor.changeStatusAt,
                        houseId: permissionHouse.id,
                        node: permissionNode,
                        virtualRemotes: permission.virtualRemotes,
                        assignedVirtualRemote: permission.assignedVirtualRemote
                    }
                    d.imageURL = null;
                    if (permissionDoor.imageURL != null)
                    {
                        d.imageURL = (permissionDoor.imageURL.indexOf('http') > -1 || permissionDoor.imageURL.indexOf('file:') > -1) ?
                                        permissionDoor.imageURL
                                        :
                                        `${API.URL}${permissionDoor.imageURL.slice(1, permissionDoor.imageURL.length)}?access_token=${API.getInstance().getToken()}`;
                    }
                    else
                        d.imageURL = `${API.URL}Doors/${permissionDoor.id}/image?access_token=${API.getInstance().getToken()}`

                    d.myPermission = {}
                    if (permission.startDate != null)
                        d.myPermission.startDate = permission.startDate;

                    if (permission.endDate != null)
                        d.myPermission.endDate = permission.endDate;

                    if (permission.PermissionDays != null)
                        d.myPermission.permissionDays = [...permission.PermissionDays];
                    
                    if (permission.virtualRemotes != null)
                        d.myPermission.virtualRemotes = [...permission.virtualRemotes]

                    house.doors.push(d);
                }
            });

            this.houses = houses;

            this.onFinishedGettingHouses()
		})
		.catch(error =>
		{
			console.log(error)

            this.setState({ isRefreshing: false })
            
            notification.error(
            {
                //message: this.state.name,
                description: strings('garagesError'),
                placement: 'top'
            })
		});
	}
    async onFinishedGettingHouses()
    {
        let user = null
        try
        {
            user = await API.getInstance().getCurrentUser()
        }
        catch(e)
        {
            console.log(e)
        }
        
        if (user != null && (user.email.includes('@primaprix.es') ||
                             user.email.includes('@vasbe.com')))
        {
            this.houses.sort((houseA, houseB) =>
            {
                if (houseA.name < houseB.name) { return -1 }
                if (houseA.name > houseB.name) { return 1 }
                return 0
            })
        }
        // if (user != null && user.email.includes('alvaro@homyhub.com'))
        // {
        //     this.houses.sort((houseA, houseB) =>
        //     {
        //         if (houseA.id < houseB.id) { return 1 }
        //         if (houseA.id > houseB.id) { return -1 }
        //         return 0
        //     })
        // }
        
        
        this.hasCachedHouses = false
        this.cachedHouses = []

        API.getInstance().setMainHouses(this.houses)
        API.getInstance().saveCachedHouses(this.houses)
        
        this.subscribeToLiveEvents()
        this.setState(
        {
            houses: this.getFilteredHousesBySearch().slice(0, PAGE_SIZE*this.currentPage),
            isRefreshing: false
        })
    }

    onDoorClicked(door)
    {
        this.setState(
        {
            openGarageDetails: true,
            door: door,
            selectedDoorId: door.id,
            house: this.getHouseByDoor(door.id)
        }, () =>
        {
            setTimeout(() =>
            {
                let doorDiv = document.getElementById(`door-${door.id}`)
                if (doorDiv != null)
                    doorDiv.scrollIntoView({behavior: "smooth", block: "center"})
            }, 300)
        })
    }

    updateActivePermissions()
    {
        console.log('Recalculating active permissions...');
        this.forceUpdate();
    }
    doorChanged(door)
    {
        var houses = [];

        for (var i = 0; i < this.state.houses.length; i++)
        {
            var house = {...this.state.houses[i]};
            
            var doors = []
            if (house.doors != null)
            {
                for (var j = 0; j < house.doors.length; j++)
                {
                    let d = {...house.doors[j]};
                    if (d.id == door.id)
                    {
                        d = {...door};
                    }
                    doors.push(d);
                }
                
                if (doors.length > 0)
                    house.doors = doors;
            }
            
            var nodes = []
            if (house.nodes != null)
            {
                for (var k = 0; k < house.nodes.length; k++)
                {
                    var node = {...house.nodes[k]};
                    
                    var nodeDoors = []
                    if (node.doors != null)
                    {
                        for (var l = 0; l < node.doors.length; l++)
                        {
                            var nodeDoor = {...node.doors[l]};
                            if (nodeDoor.id == door.id)
                            {
                                nodeDoor = {...door};
                            }
                            nodeDoors.push(nodeDoor);
                        }
                        
                        if (nodeDoors.length > 0)
                            node.doors = nodeDoors;
                        
                        nodes.push(node);
                    }
                }
                
                if (nodes.length > 0)
                    house.nodes = nodes;
            }

            houses.push(house);
        }

        this.setState({ houses });
    }
    
    subscribeToLiveEvents()
    {
        let doorIdsArr = []

        this.houses.forEach((house) =>
        {
            if (house.doors != null && house.doors.length > 0)
            {
                house.doors.forEach((door) =>
                {
                    if (door.id != null)
                        doorIdsArr.push(door.id)
                })
            }
            if (house.nodes != null && house.nodes.length > 0)
            {
                house.nodes.forEach((node) =>
                {
                    if (node.doors != null && node.doors.length > 0)
                    {
                        node.doors.forEach((door) =>
                        {
                            if (door.id != null)
                                doorIdsArr.push(door.id)
                        })
                    }
                })
            }
        })

        SSE.getInstance().getLiveEvents(doorIdsArr)
    }
    
    
    /*** INFINITE SCROLL AND SEARCH ***/
    onScrolledToBottom()
    {
        let houses = this.getFilteredHousesBySearch()
        
        if (houses.length <= this.currentPage*PAGE_SIZE)
            return
        
        this.currentPage++
        this.setState({ houses: houses.slice(0, PAGE_SIZE*this.currentPage) })
    }
    
    onSearchInput(event)
    {
        let input = event?.target?.value?.trim()
        
        this.setState({ searchInput: input }, () =>
        {
            // No search -> reset houses
            if (input.length === 0)
            {
                this.currentPage = 1
                this.setState({
                    houses: this.getVisibleHouses().slice(0, PAGE_SIZE*this.currentPage),
                    searchInput: null
                })
            }
            
            if (input.length < 3)
                return
            
            this.currentPage = 1                         
            this.setState({ houses: this.getFilteredHousesBySearch().slice(0, PAGE_SIZE*this.currentPage) })
        })
    }
    
    getFilteredHousesBySearch()
    {
        let filteredHouses = this.getVisibleHouses()
        let searchStr = this.state.searchInput?.toLowerCase()
        
        if (searchStr != null)
        {
            // Filter houses
            filteredHouses = filteredHouses?.filter(h => ( h.name.toLowerCase().includes(searchStr) ||
                                                        h?.doors?.some(d => d.name.toLowerCase().includes(searchStr)) ||
                                                        h?.nodes?.some(n => n?.doors?.some(d => d.name.toLowerCase().includes(searchStr))) ))
        }
        
        return filteredHouses
    }
    /*** INFINITE SCROLL AND SEARCH ***/
}